/// <reference path="tsdeclarations\addinCommands.d.ts" />
/// <reference path="ribbon/RibbonIdMap.ts" />
/// <reference path="../runtime/Utilities/WAC/ParserUtility.ts" />
declare var otel: any;

module OfficeExt {
  export module Parser {
    const OfficeControlNodeName = "OfficeControl";

    interface Error {
      name: string;
      message: string;
    }

    class AddInManifestException implements Error {
      name: string;
      message: string;

      constructor(message: string) {
        this.name = "AddinManifestError";
        this.message = this.name + ": " + message;
        console.error(this.message);
      }
    }

    class AddInInternalException implements Error {
      name: string;
      message: string;

      constructor(message: string) {
        this.name = "AddinInternalError";
        this.message = message;
      }
    }

    function CheckValueNotNullNorUndefined(objectValue: any, errorMessage: string) {
      if (objectValue == null) {
        throw new AddInManifestException(errorMessage);
      }
    }

    function CheckValueNotContainsInvalidCharacters(stringValue: string, errorMessage: string) {
      // On desktop side did the similar checking at %SRCROOT%\osfclient\osfmanifest\OsfManifestParser.cpp
      // Method: OsfManifestParser::VerifyValidNonMemoText(const WCHAR* wzText, ParserContext* pContext)
      const invalidChars = "\r\n\f\b\v\u0007\t"; // We replace '\a' with '\u0007' in javascript.
      for (let i = 0; i < invalidChars.length; ++i) {
        if (stringValue.indexOf(invalidChars[i]) >= 0) {
          throw new AddInManifestException(errorMessage);
        }
      }
    }

    function GetActionType(action: Mos.Actions): string {
      const type: string = action.type;
      return type === "openPage" ? "ShowTaskpane" : type === "executeFunction" ? "ExecuteFunction" : type;
    }

    let resIdCounter: number = 0;

    export class ManifestResourceManager {
      Images: {};
      Urls: {};
      LongStrings: {};
      ShortStrings: {};
      AllLocaleImages: {};
      AllLocaleUrls: {};
      AllLocaleLongStrings: {};
      AllLocaleShortStrings: {};
      namespace: string;

      constructor(context: ParsingContext, namespace?: string, versionOverridesNumber?: OSF.VersionOverridesNumber) {
        this.Images = {};
        this.Urls = {};
        this.LongStrings = {};
        this.ShortStrings = {};
        this.namespace = OSF.GetNamespaceOrDefault(namespace);

        if (context.manifest.getPayloadType() === OSF.PayloadType.OfficeAddin) {
          let xmlProcessor = context.manifest._xmlProcessor;
          var officeAppNode = xmlProcessor.selectSingleNode("o:OfficeApp");

          var resourcesNode;
          if (context.manifest.isForOfficeAppManifest()) {
            this.AllLocaleImages = {};
            this.AllLocaleUrls = {};
            this.AllLocaleLongStrings = {};
            this.AllLocaleShortStrings = {};

            if (versionOverridesNumber == null) {
              versionOverridesNumber = OSF.VersionOverridesNumber.V1_0;
            }

            let resourcesNodePath: string[] = OSF.GetVersionOverridesPath(
              xmlProcessor,
              this.namespace,
              versionOverridesNumber,
            );
            resourcesNodePath.push(
              OSF.GetVersionOverridesNamespace(this.namespace, versionOverridesNumber) + OSF.ParserStrings.Resources,
            );
            resourcesNode = OSF.SelectSingleNode(xmlProcessor, officeAppNode, resourcesNodePath, true /*isStrictPath*/);

            this.parseCollection(
              context,
              OSF.SelectChildNodes(xmlProcessor, "bt:Image", resourcesNode, ["bt:Images"]),
              this.Images,
              this.AllLocaleImages,
            );
            this.parseCollection(
              context,
              OSF.SelectChildNodes(xmlProcessor, "bt:Url", resourcesNode, ["bt:Urls"]),
              this.Urls,
              this.AllLocaleUrls,
            );
            this.parseCollection(
              context,
              OSF.SelectChildNodes(xmlProcessor, "bt:String", resourcesNode, ["bt:LongStrings"]),
              this.LongStrings,
              this.AllLocaleLongStrings,
            );
            this.parseCollection(
              context,
              OSF.SelectChildNodes(xmlProcessor, "bt:String", resourcesNode, ["bt:ShortStrings"]),
              this.ShortStrings,
              this.AllLocaleShortStrings,
            );
          } else {
            resourcesNode = OSF.SelectSingleNode(xmlProcessor, officeAppNode, [
              this.namespace + "VersionOverrides",
              this.namespace + "Resources",
            ]);

            this.parseCollection(
              context,
              OSF.SelectChildNodes(xmlProcessor, "bt:Image", resourcesNode, ["bt:Images"]),
              this.Images,
            );
            this.parseCollection(
              context,
              OSF.SelectChildNodes(xmlProcessor, "bt:Url", resourcesNode, ["bt:Urls"]),
              this.Urls,
            );
            this.parseCollection(
              context,
              OSF.SelectChildNodes(xmlProcessor, "bt:String", resourcesNode, ["bt:LongStrings"]),
              this.LongStrings,
            );
            this.parseCollection(
              context,
              OSF.SelectChildNodes(xmlProcessor, "bt:String", resourcesNode, ["bt:ShortStrings"]),
              this.ShortStrings,
            );
          }
        }
      }

      private parseCollection(context: ParsingContext, nodes, map: {}, allLocaleMaps?: {}): void {
        var len = nodes.length;
        for (var i = 0; i < len; i++) {
          var node = nodes[i];
          var id = node.getAttribute("id");

          if (allLocaleMaps != null) {
            allLocaleMaps[id] = {};
            map[id] = context.parseLocaleAwareSettingsAndGetValue(node, allLocaleMaps[id]);
          } else {
            map[id] = context.parseLocaleAwareSettingsAndGetValue(node);
          }
        }
      }
    }

    export class ParsingContext {
      hostType: string;
      formFactor: string;
      entitlement: AddinEntitlement;
      manifest: Manifest;
      resources: ManifestResourceManager;
      officeGroupCount: number;
      officeControlCount: number;
      insertBefore: string;
      insertAfter: string;
      namespace: string;

      constructor(
        hostType: string,
        formFactor: string,
        entitlement: AddinEntitlement,
        manifest: Manifest,
        namespace?: string,
        versionOverridesNumber?: OSF.VersionOverridesNumber,
      ) {
        this.hostType = hostType;
        this.formFactor = formFactor;
        this.entitlement = entitlement;
        this.manifest = manifest;
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
        this.resources = new ManifestResourceManager(this, this.namespace, versionOverridesNumber);
        this.officeGroupCount = 0;
        this.officeControlCount = 0;
      }

      shouldParseNode(node): boolean {
        var overriddenByRibbonApi = this.manifest._xmlProcessor.selectSingleNode(
          this.namespace + "OverriddenByRibbonApi",
          node,
        );
        if (
          overriddenByRibbonApi != null &&
          this.manifest._parseBooleanNode(overriddenByRibbonApi) &&
          !this.manifest.isForOfficeAppManifest()
        ) {
          return false;
        }
        return true;
      }

      shouldParseNodeFromMos(node: any): boolean {
        /**
         * OverriddenByRibbonApi is an optional boolean type property for Group or Control.
         * When OverriddenByRibbonApi is true, we should not parse the node from Mos, so the Group or Control is overridden and won't be displayed.
         * By default, OverriddenByRibbonApi is false.
         */
        return !node.overriddenByRibbonApi;
      }

      parseIdRequired(node): string {
        var id = node.getAttribute("id");
        CheckValueNotNullNorUndefined(id, "Id required");
        return id;
      }

      parseIdRequiredFromMos(node: any): string {
        let id: string = node.id;
        CheckValueNotNullNorUndefined(id, "Id required");
        return id;
      }

      parseLabel(node): string {
        var child = this.manifest._xmlProcessor.selectSingleNode(this.namespace + "Label", node);
        if (child != null) {
          return this.getShortString(child);
        }
        return null;
      }

      parseLabelRequired(node): string {
        var label = this.parseLabel(node);
        CheckValueNotNullNorUndefined(label, "Label required");
        return label;
      }

      parseLabelRequiredFromMos(node: Mos.Tabs | Mos.Groups | Mos.Controls): string {
        let label: string = node.label;
        CheckValueNotNullNorUndefined(label, "Label required");
        return label;
      }

      parseResId(node): string {
        if (node != null) {
          return node.getAttribute("resid");
        }
        return null;
      }

      parseType(node): string {
        if (node != null) {
          return node.getAttribute("type");
        }
        return null;
      }

      parseRequiredSuperTip(node): SuperTip {
        var superTip = this.parseSuperTip(node);
        CheckValueNotNullNorUndefined(superTip, "SuperTip required");
        return superTip;
      }

      parseRequiredSupertipFromMos(node): SuperTip {
        const supertip = this.parseSupertipFromMos(node);
        CheckValueNotNullNorUndefined(supertip, "supertip required");
        return supertip;
      }

      parseSuperTip(node): SuperTip {
        var superTip = null;
        var child = this.manifest._xmlProcessor.selectSingleNode(this.namespace + "Supertip", node);

        if (child != null) {
          var tipNode = child;
          var title, description, titleResId, descriptionResId;
          child = this.manifest._xmlProcessor.selectSingleNode(this.namespace + "Title", tipNode);
          CheckValueNotNullNorUndefined(child, "Title is necessary for SuperTip.");
          title = this.getShortString(child);
          child = this.manifest._xmlProcessor.selectSingleNode(this.namespace + "Description", tipNode);
          CheckValueNotNullNorUndefined(child, "Description is necessary for SuperTip.");
          description = this.getLongString(child);

          superTip = {
            title: title,
            description: description,
          };

          if (this.manifest.isForOfficeAppManifest()) {
            child = this.manifest._xmlProcessor.selectSingleNode(this.namespace + "Title", tipNode);
            superTip.titleResId = this.parseResId(child);
            child = this.manifest._xmlProcessor.selectSingleNode(this.namespace + "Description", tipNode);
            superTip.descriptionResId = this.parseResId(child);
          }
        }

        return superTip;
      }

      parseSupertipFromMos(control: Mos.Controls): SuperTip {
        let supertip = null;
        const child: Mos.Supertip = control.supertip;

        if (child != null) {
          const title: string = child.title;
          CheckValueNotNullNorUndefined(title, "Title is necessary for Supertip.");
          CheckValueNotContainsInvalidCharacters(title, "Invalid characters in text value: " + title);
          const description: string = child.description;
          CheckValueNotNullNorUndefined(description, "Description is necessary for Supertip.");
          CheckValueNotContainsInvalidCharacters(description, "Invalid characters in text value: " + description);
          supertip = {
            title: title,
            description: description,
          };
        }

        return supertip;
      }

      parseRequiredIcon(node): {} {
        var icon = this.parseIcon(node);
        CheckValueNotNullNorUndefined(icon, "Icon required");

        return icon;
      }

      parseRequiredIconFromMos(node: Mos.Groups | Mos.Controls): {} {
        let icon: {} = this.parseIconFromMos(node);
        CheckValueNotNullNorUndefined(icon, "Icon required");

        return icon;
      }

      parseOptionalIcon(node): {} {
        return this.parseIcon(node);
      }

      parseOptionalIconFromMos(node: Mos.Groups): {} {
        return this.parseIcon(node);
      }

      parseIcon(node): {} {
        var iconNodes = OSF.SelectChildNodes(this.manifest._xmlProcessor, "bt:Image", node, [this.namespace + "Icon"]);
        var len = iconNodes.length;

        if (len == 0) {
          return null;
        }

        var icon = {};
        for (var i = 0; i < len; i++) {
          var iconNode = iconNodes[i];
          var size = iconNode.getAttribute("size");
          icon[size] = this.getImageResource(iconNode);
        }

        return icon;
      }

      parseIconFromMos(node: Mos.Groups | Mos.Controls): {} {
        const iconNodes: Mos.Icons[] = node.icons;
        const len: number = iconNodes?.length;

        if (!len || len == 0) {
          return null;
        }

        let icons: {} = {};
        for (const icon of iconNodes) {
          this.AddResourceMapAndGetIdHelper(icon.url, this.resources.Images);
          const size: number = icon.size;
          icons[size] = icon.url;
        }
        return icons;
      }

      parseIconResId(node) {
        var iconNodes = OSF.SelectChildNodes(this.manifest._xmlProcessor, "bt:Image", node, [this.namespace + "Icon"]);
        var len = iconNodes.length;

        if (len == 0) {
          return null;
        }

        var iconResId = {};
        for (var i = 0; i < len; i++) {
          var iconNode = iconNodes[i];
          var size = iconNode.getAttribute("size");
          if (size != null) {
            iconResId[size] = iconNode.getAttribute("resid");
          }
        }

        return iconResId;
      }

      AddResourceMapAndGetIdHelper(resourceValue: string, resourceMap: {}): void {
        CheckValueNotNullNorUndefined(resourceMap, "resourceMap is not found.");
        resIdCounter++;
        resourceMap[resIdCounter] = resourceValue;
      }

      checkRequiredGroupIcons(icons: any) {
        CheckValueNotNullNorUndefined(icons[16], "Icons are missing required size 16");
        CheckValueNotNullNorUndefined(icons[32], "Icons are missing required size 32");
        CheckValueNotNullNorUndefined(icons[80], "Icons are missing required size 80");
      }

      parseMultipleChildControls(
        childNodeNames: string[],
        node: any,
        parser: (context: ParsingContext, node: any) => any,
      ): any[] {
        var controls = [];
        for (var idx = 0; idx < node.childNodes.length; idx++) {
          if (childNodeNames.indexOf(node.childNodes[idx].nodeName) !== -1) {
            controls.push(node.childNodes[idx]);
          }
        }
        return this.parseControls(controls, parser);
      }

      parseMultipleChildControlsFromMos(
        childNodeNames: string[],
        node: any,
        parseControlFromMos: (context: ParsingContext, node: Mos.Groups | Mos.Controls) => any,
      ): any[] {
        let controls: Mos.Groups[] | Mos.Controls[] = [];

        if (childNodeNames[0] == "Group") {
          for (const group of node.groups) {
            controls.push(group);
          }
        } else {
          for (const control of node.controls) {
            controls.push(control);
          }
        }

        return this.parseControlsFromMos(controls, parseControlFromMos);
      }

      parseChildControls(childNodeName: string, node: any, parser: (context: ParsingContext, node: any) => any): any[] {
        var controls = this.manifest._xmlProcessor.selectNodes(childNodeName, node);
        return this.parseControls(controls, parser);
      }

      parseChildControlsFromMos(
        childNodeName: string,
        contextMenu: Mos.ContextMenus,
        parser: (context: ParsingContext, node: any) => any,
      ): any[] {
        let controls: Mos.Menus[] = contextMenu.menus;
        return this.parseControlsFromMos(controls, parser);
      }

      parseControls(nodes: any[], parser: (context: ParsingContext, node: any) => any): any[] {
        var controls = [];
        var len = nodes.length;

        for (var i = 0; i < len; i++) {
          var e = nodes[i];

          if (this.shouldParseNode(e)) {
            var control = parser(this, e);
            CheckValueNotNullNorUndefined(control, "parser must return a control.");
            controls.push(control);
          }
        }

        return controls;
      }

      parseControlsFromMos(nodes: any[], parseControlFromMos: (context: ParsingContext, node: any) => any): any[] {
        let controls: any[] = [];

        for (const e of nodes) {
          if (this.shouldParseNodeFromMos(e)) {
            const control: any = parseControlFromMos(this, e);
            CheckValueNotNullNorUndefined(control, "parseControlFromMos must return a control.");
            controls.push(control);
          }
        }

        return controls;
      }

      parseGroupUnderTab(node): RibbonGroup | OfficeGroup {
        let group: RibbonGroup;

        switch (node.nodeName) {
          case "OfficeGroup":
            group = new OfficeGroup(this.hostType);
            this.officeGroupCount++;
            break;
          default:
            group = new RibbonGroup(this.hostType);
        }

        group.parse(this, node);
        return group;
      }

      parseGroupUnderTabFromMos(group: Mos.Groups): RibbonGroup | OfficeGroup {
        let newGroup: RibbonGroup;

        if (group.id == null) {
          newGroup = new OfficeGroup(this.hostType);
          this.officeGroupCount++;
        } else {
          newGroup = new RibbonGroup(this.hostType);
        }

        newGroup.parseFromMos(this, group);
        return newGroup;
      }

      parseControlInGroup(node): any {
        var controlType = this.manifest.getNodeXsiType(node);
        var control: UIControlNode;

        if (!controlType && node.nodeName === OfficeControlNodeName) {
          controlType = "OfficeControl";
        }

        switch (controlType) {
          case "Menu":
            control = new MenuControl(controlType, this.namespace);
            break;
          case "Button":
            control = new Button(controlType, this.namespace);
            break;
          case "OfficeControl":
            control = new OfficeControl();
            this.officeControlCount++;
            break;
          default:
            throw new AddInManifestException("Unsupported control type.");
        }

        control.parse(this, node);
        return control;
      }

      parseControlInGroupFromMos(control: Mos.Controls): UIControlNode {
        let controlType: string = control.type;
        let newControl: UIControlNode;

        if (controlType == null) {
          controlType = "OfficeControl";
        }

        switch (controlType) {
          case "menu":
            newControl = new MenuControl("Menu");
            break;
          case "button":
            newControl = new Button("Button");
            break;
          case "OfficeControl":
            newControl = new OfficeControl();
            this.officeControlCount++;
            break;
          default:
            throw new AddInManifestException("Unsupported control type.");
        }

        newControl.parseFromMos(this, control);
        return newControl;
      }

      parseMenuItem(node): any {
        var item: UIControlNode = new MenuItem(this.namespace);
        item.parse(this, node);
        return item;
      }

      parseMenuItemFromMos(node: Mos.Controls): UIControlNode {
        let item: UIControlNode = new MenuItem();
        item.parseFromMos(this, node);
        return item;
      }

      parseLocaleAwareSettingsAndGetValue(node, allLocaleMap?: {}): any {
        const forAllLocales: boolean = allLocaleMap != null;
        let values: object = forAllLocales ? allLocaleMap : {};
        var defaultValue = node.getAttribute("DefaultValue");
        values[this.manifest._defaultLocale] = defaultValue;
        values[this.manifest._defaultLocale.toLocaleLowerCase()] = defaultValue;
        var overrideNodes = this.manifest._xmlProcessor.selectNodes("bt:Override", node);

        if (overrideNodes) {
          var len = overrideNodes.length;

          for (var i = 0; i < len; i++) {
            var node = overrideNodes[i];
            var locale = node.getAttribute("Locale");
            var value = node.getAttribute("Value");

            if (!forAllLocales) {
              values[locale] = value;
            }

            values[locale.toLocaleLowerCase()] = value;

            // Current code assumes that Locale attribute is non null and not undefined so continuing this assumption
            if (this.manifest.isForOfficeAppManifest()) {
              this.manifest.addLocaleSeen(locale);
            }
          }
        }
        return this.manifest._getDefaultValue(values);
      }

      // Since XmlProcessor can't support xpath query, here we write a method to select grandchild (or deeper) level descendant node.
      selectSingleNode(node: any, path: Array<string>): any {
        if (path == null) return node;

        for (var i = 0; i < path.length; i++) {
          node = this.manifest._xmlProcessor.selectSingleNode(path[i], node);
          if (node == null) {
            break;
          }
        }

        return node;
      }

      // Similar to selectSingleNode, select grandchild (or deeper) level descendant nodes.
      selectChildNodes(name: string, node: any, path: Array<string>): any {
        node = this.selectSingleNode(node, path);
        if (node == null) {
          return [];
        }
        return this.manifest._xmlProcessor.selectNodes(name, node);
      }

      getSingleNodeValue(nodeName: string, parentNode: any): string {
        let node = this.manifest._xmlProcessor.selectSingleNode(nodeName, parentNode);
        if (node) {
          return this.manifest._xmlProcessor.getNodeValue(node);
        }
        return "";
      }

      getResourceByNode(resources: {}, resourceNode): any {
        var resid = resourceNode.getAttribute("resid");
        var res = resources[resid];
        if (this.manifest.isForOfficeAppManifest() && res == null) {
          if (this.manifest.converterLogging()) {
            console.error("\x1b[31m%s\x1b[0m", "WARNING: resid: " + resid + " is not defined.");
          }
          res = "";
        } else {
          CheckValueNotNullNorUndefined(res, "resid: " + resid + " not found");
        }
        return res;
      }

      getImageResource(resourceNode): any {
        return this.getResourceByNode(this.resources.Images, resourceNode);
      }

      getUrlResource(resourceNode): any {
        return this.getResourceByNode(this.resources.Urls, resourceNode);
      }

      getLongString(resourceNode): any {
        const longString = this.getResourceByNode(this.resources.LongStrings, resourceNode);
        CheckValueNotContainsInvalidCharacters(longString, "Invalid characters in text value: " + longString);
        return longString;
      }

      getShortString(resourceNode): any {
        const shortString = this.getResourceByNode(this.resources.ShortStrings, resourceNode);
        CheckValueNotContainsInvalidCharacters(shortString, "Invalid characters in text value: " + shortString);
        return shortString;
      }

      getContextMenuType(menu: Mos.Menus): string {
        switch (menu?.entryPoint) {
          case "cell":
            return "ContextMenuCell";
          case "text":
            return "ContextMenuText";
          default:
            throw new AddInManifestException("Unsupported context menu type.");
        }
      }
      getLabelChildNode(node: any, namespace: string) {
        var labelNode = this.manifest._xmlProcessor.selectSingleNode(namespace + "Label", node);
        return labelNode;
      }
    }

    class BuildHelpers {
      static buildControls(context: UIControlBuildingContext, controls: UIControlNode[]): void {
        var len = controls.length;
        for (var i = 0; i < len; i++) {
          var child = controls[i];
          child.apply(context);
        }
      }
    }

    interface UIControlBuildingContext {
      functionFile: string;
      actionBuilder: ActionBuilder;
      controlBuilder: UIControlBuilder;
    }

    class AddinBuildingContext {
      functionFile: string;
      builder: AddinBuilder;
      multipleCustomTabsEnabled: boolean = false;

      constructor(functionFile: string, builder: AddinBuilder, multipleCustomTabsEnabled = false) {
        this.functionFile = functionFile;
        this.builder = builder;
        this.multipleCustomTabsEnabled = multipleCustomTabsEnabled;
      }
    }

    interface NodeParser {
      parse(context: ParsingContext, node): void;
      parseFromMos(context: ParsingContext, node): void;
    }

    interface ExtensionPoint extends NodeParser {
      type: string;
      apply(context: AddinBuildingContext): void;
    }

    interface ExtensionPointAction extends NodeParser {
      type: string;
      buildAction(context: UIControlBuildingContext): any;
    }

    interface UIControlNode extends NodeParser {
      apply(context: UIControlBuildingContext): void;
    }

    class GetStartedNode implements NodeParser {
      title: string;
      description: string;
      learnMoreUrl: string;
      namespace: string;

      constructor(namespace?: string) {
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      parse(context: ParsingContext, node): void {
        var xmlProcessor = context.manifest._xmlProcessor;
        var titleNode = xmlProcessor.selectSingleNode(this.namespace + "Title", node);
        CheckValueNotNullNorUndefined(titleNode, "Title is necessary for GetStarted.");
        this.title = context.getShortString(titleNode);
        var descriptionNode = xmlProcessor.selectSingleNode(this.namespace + "Description", node);
        CheckValueNotNullNorUndefined(descriptionNode, "Description is necessary for GetStarted.");
        this.description = context.getLongString(descriptionNode);
        var learnMoreNode = xmlProcessor.selectSingleNode(this.namespace + "LearnMoreUrl", node);
        this.learnMoreUrl = context.getUrlResource(learnMoreNode);
      }

      parseFromMos(context: ParsingContext, getStartedMessage: Mos.GetStartedMessages): void {
        this.title = getStartedMessage.title;
        this.description = getStartedMessage.description;
        this.learnMoreUrl = getStartedMessage.learnMoreUrl;
      }
    }

    class ActionBase implements ExtensionPointAction {
      type: string;
      namespace: string;

      constructor(type: string, namespace?: string) {
        this.type = type;
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      buildAction(context: UIControlBuildingContext): any {}

      parse(context: ParsingContext, node): void {}

      parseFromMos(context: ParsingContext, node): void {}
    }

    class ShowUIAction extends ActionBase {
      title: string = null;
      sourceLocation: string;

      parse(context: ParsingContext, node): void {
        var child = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "SourceLocation", node);
        CheckValueNotNullNorUndefined(child, "SourceLocation is necessary for ShowTaskpane action");
        this.sourceLocation = context.getUrlResource(child);
        context.manifest.addManifestUrl(this.sourceLocation);
      }

      parseFromMos(context: ParsingContext, node: Mos.Actions): void {
        const runtime: Mos.Runtimes = context.manifest.getExtensionRuntimeByActionId(node.id);
        this.sourceLocation = runtime.code.page;
        context.manifest.addManifestUrl(this.sourceLocation);
      }
    }

    class ShowTaskPaneAction extends ShowUIAction {
      taskpaneId: string;
      sourceLocationResid: string;
      pinnable: boolean = false;

      buildAction(context: UIControlBuildingContext): any {
        return context.actionBuilder.buildShowTaskpane(
          this.sourceLocation,
          this.title,
          this.taskpaneId,
          this.sourceLocationResid,
        );
      }

      parse(context: ParsingContext, node): void {
        super.parse(context, node);
        var child = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "TaskpaneId", node);
        if (child != null) {
          this.taskpaneId = child.firstChild.nodeValue;
        }

        // Having "SourceLocation " with a space is surely a bug but fixing this could change the behavior
        // of the wac parser and scenarios so for now keeping this fixed implementation only for the XML to JSON converter.
        if (context.manifest.isForOfficeAppManifest()) {
          child = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "SourceLocation", node);
        } else {
          child = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "SourceLocation ", node);
        }
        if (child != null) {
          this.sourceLocationResid = child.getAttribute("resid");
        }
        child = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Title", node);
        if (child != null) {
          this.title = context.getShortString(child);
        }

        if (context.manifest.isForOfficeAppManifest()) {
          var supportsPinningNode = context.manifest._xmlProcessor.selectSingleNode(
            this.namespace + "SupportsPinning",
            node,
          );
          if (supportsPinningNode != null) {
            this.pinnable = context.manifest._parseBooleanNode(supportsPinningNode);
          }
        }
      }

      parseFromMos(context: ParsingContext, node: Mos.Actions): void {
        super.parseFromMos(context, node);

        const runtime: Mos.Runtimes = context.manifest.getExtensionRuntimeByActionId(node.id);
        if (runtime != null) {
          this.sourceLocationResid = runtime.id;

          this.taskpaneId = null;
          const action: Mos.Actions = context.manifest.getExtensionActionById(node.id);
          if (action != null && action.view != null) {
            this.taskpaneId = action.view;
          }

          if (action.displayName != null) {
            this.title = action.displayName;
          }
        }
      }
    }

    class ExecuteFunctionAction extends ActionBase {
      functionName: string;
      controlId: string;

      buildAction(context: UIControlBuildingContext): any {
        CheckValueNotNullNorUndefined(
          context.functionFile,
          "Valid FunctionFile source url is necessary for ExecuteFunctionAction.",
        );
        return context.actionBuilder.buildCallFunction(context.functionFile, this.functionName, this.controlId);
      }

      parse(context: ParsingContext, node): void {
        var child = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "FunctionName", node);
        CheckValueNotNullNorUndefined(child, "FunctionName is necessary for ExecuteFunctionAction.");
        this.functionName = context.manifest._xmlProcessor.getNodeValue(child);
      }

      parseFromMos(conext: ParsingContext, node: Mos.Actions): void {
        const functionName: string = node.displayName;
        CheckValueNotNullNorUndefined(
          functionName,
          "Parsing from Mos: FunctionName is necessary for ExecuteFunctionAction.",
        );
        this.functionName = functionName;
      }
    }

    class UIEntityBase implements UIEntity, NodeParser {
      id: string;
      label: string;

      parse(context: ParsingContext, node): void {
        this.id = context.parseIdRequired(node);
        this.label = context.parseLabelRequired(node);
      }

      parseFromMos(context: ParsingContext, node: Mos.Tabs | Mos.Groups | Mos.Controls): void {
        this.id = context.parseIdRequiredFromMos(node);
        this.label = context.parseLabelRequiredFromMos(node);
      }
    }

    export class MenuControl extends UIEntityBase implements UIControlNode, UIControl {
      controlType: string;
      children: UIControlNode[];
      icon: {};
      iconResId: {};
      superTip: SuperTip;
      namespace: string;
      labelResId: string;

      constructor(controlType?: string, namespace?: string) {
        super();
        this.controlType = controlType;
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      apply(context: UIControlBuildingContext): void {
        context.controlBuilder.startBuildMenu(this);
        BuildHelpers.buildControls(context, this.children);
        context.controlBuilder.endBuildMenu();
      }

      parse(context: ParsingContext, node): void {
        if (!context.shouldParseNode(node)) {
          return;
        }

        super.parse(context, node);
        this.icon = context.parseRequiredIcon(node);

        if (context.manifest.isForOfficeAppManifest()) {
          this.iconResId = context.parseIconResId(node);
        }

        this.superTip = context.parseRequiredSuperTip(node);
        var controls = OSF.SelectChildNodes(context.manifest._xmlProcessor, this.namespace + "Item", node, [
          this.namespace + "Items",
        ]);
        if (context.manifest.isForOfficeAppManifest()) {
          let labelChild: object = null;
          labelChild = context.manifest._xmlProcessor.selectSingleNode(context.namespace + "Label", node);
          this.labelResId = context.parseResId(labelChild);
        }

        this.children = context.parseControls(controls, (context, node) => {
          return context.parseMenuItem(node);
        });
      }

      parseFromMos(context: ParsingContext, node: Mos.Controls): void {
        if (!context.shouldParseNodeFromMos(node)) {
          return;
        }

        super.parseFromMos(context, node);
        this.icon = context.parseRequiredIconFromMos(node);
        this.superTip = context.parseRequiredSupertipFromMos(node);
        const controls: Mos.Controls[] = node.items;

        this.children = context.parseControlsFromMos(controls, (context: ParsingContext, item: Mos.Controls) => {
          return context.parseMenuItemFromMos(item);
        });
      }
    }

    class ItemControl extends UIEntityBase implements UIControlNode, UIControl {
      controlType: string;
      icon: {};
      iconResId: {};
      superTip: SuperTip;
      action: ExtensionPointAction;
      actionType: string;
      enabled: boolean = true;
      namespace: string;
      labelResId: string;

      constructor(controlType: string, namespace?: string) {
        super();
        this.controlType = controlType;
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      apply(context: UIControlBuildingContext): void {
        var action = this.action.buildAction(context);
        var control = {
          id: this.id,
          label: this.label,
          icon: this.icon,
          superTip: this.superTip,
          actionType: this.actionType,
          action: action,
          enabled: this.enabled,
        };
        this.applyControl(context, control);
      }

      parse(context: ParsingContext, node): void {
        super.parse(context, node);
        this.icon = this.parseIcon(context, node);

        if (context.manifest.isForOfficeAppManifest()) {
          this.iconResId = context.parseIconResId(node);
        }

        this.superTip = context.parseRequiredSuperTip(node);
        var child = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Action", node);
        CheckValueNotNullNorUndefined(child, "Action is necessary for itemControl.");

        var actionType = context.manifest.getNodeXsiType(child);
        var action: ActionBase;
        switch (actionType) {
          case "ShowTaskpane":
            action = new ShowTaskPaneAction(actionType, this.namespace);
            break;
          case "ExecuteFunction":
            var execAction = (action = new ExecuteFunctionAction(actionType, this.namespace));
            execAction.controlId = this.id;
            break;
          default:
            throw new AddInManifestException("Unsupported action type.");
        }

        action.parse(context, child);
        this.actionType = actionType;
        this.action = action;

        var enabledNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Enabled", node);
        if (enabledNode != null) {
          this.enabled = context.manifest._parseBooleanNode(enabledNode);
        }

        if (context.manifest.isForOfficeAppManifest()) {
          let labelChild: object = null;
          labelChild = context.manifest._xmlProcessor.selectSingleNode(context.namespace + "Label", node);
          this.labelResId = context.parseResId(labelChild);
        }
      }

      parseFromMos(context: ParsingContext, control: Mos.Controls): void {
        super.parseFromMos(context, control);
        this.icon = this.parseIconFromMos(context, control);
        this.superTip = context.parseRequiredSupertipFromMos(control);

        const child: Mos.Actions = context.manifest.getExtensionActionById(control.actionId);
        CheckValueNotNullNorUndefined(child, "Parsing from Mos: Action is necessary for itemControl.");

        const actionType: string = GetActionType(child);
        let action: ActionBase;
        switch (actionType) {
          case "ShowTaskpane":
            action = new ShowTaskPaneAction(actionType, this.namespace);
            break;
          case "ExecuteFunction":
            let execAction: ExecuteFunctionAction = (action = new ExecuteFunctionAction(actionType, this.namespace));
            execAction.controlId = this.id;
            break;
          default:
            throw new AddInManifestException("Parsing from Mos: Unsupported action type.");
        }

        action.parseFromMos(context, child);
        this.actionType = actionType;
        this.action = action;
        this.enabled = control.enabled ? control.enabled : true;
      }

      applyControl(context: UIControlBuildingContext, control: UIControlActionable): void {
        throw new AddInInternalException("Not implemented method applyControl for ItemControl.");
      }

      parseIcon(context: ParsingContext, node): {} {
        return context.parseIcon(node);
      }

      parseIconFromMos(context: ParsingContext, node: Mos.Groups | Mos.Controls): {} {
        return context.parseIconFromMos(node);
      }
    }

    class Button extends ItemControl {
      applyControl(context: UIControlBuildingContext, control: UIControlActionable): void {
        context.controlBuilder.addButton(control);
      }

      parseIcon(context: ParsingContext, node): {} {
        return context.parseRequiredIcon(node);
      }
    }

    class MenuItem extends ItemControl {
      constructor(namespace?: string) {
        super("MenuItem", namespace);
      }

      applyControl(context: UIControlBuildingContext, control: UIControlActionable): void {
        context.controlBuilder.addMenuItem(control);
      }
    }

    class OfficeControl extends ItemControl {
      constructor() {
        super("OfficeControl");
        this.label = null;
        this.icon = null;
        this.superTip = null;
        this.actionType = null;
        this.action = null;
        this.enabled = true;
      }

      apply(context: UIControlBuildingContext): void {
        var control = {
          id: this.id,
          label: this.label,
          icon: this.icon,
          superTip: this.superTip,
          actionType: this.actionType,
          action: this.action,
          enabled: this.enabled,
        };
        this.applyControl(context, control);
      }

      parse(context: ParsingContext, node): void {
        try {
          this.id = context.parseIdRequired(node);
        } catch (ex) {
          throw new AddInManifestException("Required id attribute missing for OfficeControl.");
        }

        if (OSF.RibbonControlIdMap && OSF.RibbonControlIdMap[this.id]) {
          this.id = OSF.RibbonControlIdMap[this.id];
        } else if (!OSF.OUtil.checkFlight(OSF.FlightNames.AddinRibbonIdAllowUnknown)) {
          throw new AddInManifestException("Unsupported control id for OfficeControl.");
        }
      }

      parseFromMos(context: ParsingContext, control: Mos.Controls): void {
        this.id = control.builtInControlId;
        CheckValueNotNullNorUndefined(this.id, "Built in control id is required.");

        if (OSF.RibbonControlIdMap && OSF.RibbonControlIdMap[this.id]) {
          this.id = OSF.RibbonControlIdMap[this.id];
        } else if (!OSF.OUtil.checkFlight(OSF.FlightNames.AddinRibbonIdAllowUnknown)) {
          throw new AddInManifestException("Unsupported control id for OfficeControl.");
        }
      }

      applyControl(context: UIControlBuildingContext, control: UIControlActionable): void {
        context.controlBuilder.addNativeControl(control);
      }
    }

    class RibbonTab implements OfficeExt.RibbonTab {
      id: string;
      label: string = null;
      isOfficeTab: boolean = false;
      visible: boolean = true;
      children: RibbonGroup[] = [];
      tabType: string = "default";
      insertBefore: string = "";
      insertAfter: string = "";
      autoFocus: boolean = false;
      namespace: string;

      constructor(isOfficeTab: boolean, namespace?: string) {
        this.isOfficeTab = isOfficeTab;
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      apply(context: AddinBuildingContext): void {
        context.builder.ribbonBuilder.startBuildTab(this);
        var len = this.children.length;
        for (var i = 0; i < len; i++) {
          var child = this.children[i];
          child.apply(context);
        }
        context.builder.ribbonBuilder.endBuildTab();
      }

      parse(context: ParsingContext, node): void {
        this.id = context.parseIdRequired(node);

        if (!this.isOfficeTab) {
          this.label = context.parseLabelRequired(node);

          if (OSF.Settings["IsReactRibbonEnabled"]) {
            this.insertBefore = context.getSingleNodeValue(this.namespace + "InsertBefore", node);
            this.insertAfter = context.getSingleNodeValue(this.namespace + "InsertAfter", node);

            if (this.insertBefore) {
              if (this.insertBefore === "TabHome") {
                this.autoFocus = true;
              }
              context.insertBefore = this.insertBefore;
            }

            if (this.insertAfter) {
              context.insertAfter = this.insertAfter;
            }
          }
        }

        if (OSF.Settings["IsReactRibbonEnabled"]) {
          this.children = context.parseMultipleChildControls(["Group", "OfficeGroup"], node, (context, node) => {
            return context.parseGroupUnderTab(node);
          });
        } else {
          this.children = context.parseMultipleChildControls(["Group"], node, (context, node) => {
            return context.parseGroupUnderTab(node);
          });
        }
      }

      parseFromMos(context: ParsingContext, tab: Mos.Tabs) {
        if (!this.isOfficeTab) {
          this.id = context.parseIdRequiredFromMos(tab);
          this.label = context.parseLabelRequiredFromMos(tab);

          if (OSF.Settings["IsReactRibbonEnabled"]) {
            const insertPosition: string = tab.position.align;
            if (insertPosition === "before") {
              this.insertBefore = tab.position.builtInTabId;
              if (this.insertBefore != null) {
                if (this.insertBefore === "TabHome") {
                  this.autoFocus = true;
                }
                context.insertBefore = this.insertBefore;
              }
            } else if (insertPosition === "after") {
              this.insertAfter = tab.position.builtInTabId;
              if (this.insertAfter != null) {
                context.insertAfter = this.insertAfter;
              }
            } else {
              throw new AddInManifestException("Unsupported insert position");
            }
          }
        } else {
          this.id = tab.builtInTabId;
          CheckValueNotNullNorUndefined(this.id, "Built in tab id is required.");
        }

        if (OSF.Settings["IsReactRibbonEnabled"]) {
          this.children = context.parseMultipleChildControlsFromMos(
            ["Group", "OfficeGroup"],
            tab,
            (context: ParsingContext, group: Mos.Groups) => {
              return context.parseGroupUnderTabFromMos(group);
            },
          );
        } else {
          this.children = context.parseMultipleChildControlsFromMos(
            ["Group"],
            tab,
            (context: ParsingContext, group: Mos.Groups) => {
              return context.parseGroupUnderTabFromMos(group);
            },
          );
        }
      }
    }

    class RibbonGroup extends UIEntityBase {
      icon: {};
      iconResId: {};
      children: UIControlNode[];
      groupType: string = "Custom";
      hostType: string;
      labelResId: string = null;

      constructor(hostType: string) {
        super();
        this.hostType = hostType;
      }

      parse(context: ParsingContext, node): void {
        if (!context.shouldParseNode(node)) {
          return;
        }
        super.parse(context, node);

        if (context.manifest.isForOfficeAppManifest()) {
          let labelChild: object = null;
          labelChild = context.manifest._xmlProcessor.selectSingleNode(context.namespace + "Label", node);
          this.labelResId = context.parseResId(labelChild);
        }

        if (this.hostType === "MailHost") {
          this.icon = context.parseOptionalIcon(node);
        } else {
          this.icon = context.parseRequiredIcon(node);
          context.checkRequiredGroupIcons(this.icon);
        }

        if (context.manifest.isForOfficeAppManifest()) {
          this.iconResId = context.parseIconResId(node);
        }

        if (OSF.Settings["IsReactRibbonEnabled"]) {
          this.children = context.parseMultipleChildControls(["Control", "OfficeControl"], node, (context, node) => {
            return context.parseControlInGroup(node);
          });
        } else {
          this.children = context.parseMultipleChildControls(["Control"], node, (context, node) => {
            return context.parseControlInGroup(node);
          });
        }
      }

      parseFromMos(context: ParsingContext, group: Mos.Groups): void {
        if (!context.shouldParseNodeFromMos(group)) {
          return;
        }
        super.parseFromMos(context, group);

        if (this.hostType === "MailHost") {
          this.icon = context.parseOptionalIconFromMos(group);
        } else {
          this.icon = context.parseRequiredIconFromMos(group);
          context.checkRequiredGroupIcons(this.icon);
        }

        if (OSF.Settings["IsReactRibbonEnabled"]) {
          this.children = context.parseMultipleChildControlsFromMos(
            ["Control", "OfficeControl"],
            group,
            (context: ParsingContext, control: Mos.Controls) => {
              return context.parseControlInGroupFromMos(control);
            },
          );
        } else {
          this.children = context.parseMultipleChildControlsFromMos(
            ["Control"],
            group,
            (context: ParsingContext, control: Mos.Controls) => {
              return context.parseControlInGroupFromMos(control);
            },
          );
        }
      }

      apply(context: AddinBuildingContext): void {
        context.builder.ribbonBuilder.startBuildGroup(this);
        BuildHelpers.buildControls(
          {
            functionFile: context.functionFile,
            actionBuilder: context.builder.actionBuilder,
            controlBuilder: context.builder.ribbonBuilder,
          },
          this.children,
        );
        context.builder.ribbonBuilder.endBuildGroup();
      }
    }

    class OfficeGroup extends RibbonGroup {
      mlrId = "";

      constructor(hostType: string) {
        super(hostType);
        this.children = null;
        this.label = null;
        this.icon = null;
        this.groupType = "OfficeGroup";
      }

      parse(context: ParsingContext, node): void {
        try {
          this.id = context.parseIdRequired(node);
        } catch (ex) {
          throw new AddInManifestException("Required id attribute missing for OfficeGroup.");
        }

        if (OSF.RibbonGroupIdMap && OSF.RibbonGroupIdMap[this.id]) {
          if (OSF.RibbonGroupIdMapCommonMLR && OSF.RibbonGroupIdMapCommonMLR[this.id]) {
            this.mlrId = OSF.RibbonGroupIdMapCommonMLR[this.id];
          }
          this.id = OSF.RibbonGroupIdMap[this.id];
        } else if (!OSF.OUtil.checkFlight(OSF.FlightNames.AddinRibbonIdAllowUnknown)) {
          throw new AddInManifestException("Unsupported id for OfficeGroup.");
        }
      }

      parseFromMos(context: ParsingContext, group: Mos.Groups): void {
        this.id = group.builtInGroupId;
        CheckValueNotNullNorUndefined(this.id, "Built in group id is required.");

        if (OSF.RibbonGroupIdMap && OSF.RibbonGroupIdMap[this.id]) {
          if (OSF.RibbonGroupIdMapCommonMLR && OSF.RibbonGroupIdMapCommonMLR[this.id]) {
            this.mlrId = OSF.RibbonGroupIdMapCommonMLR[this.id];
          }
          this.id = OSF.RibbonGroupIdMap[this.id];
        } else if (!OSF.OUtil.checkFlight(OSF.FlightNames.AddinRibbonIdAllowUnknown)) {
          throw new AddInManifestException("Unsupported id for OfficeGroup.");
        }
      }

      apply(context: AddinBuildingContext): void {
        context.builder.ribbonBuilder.addNativeGroup(this);
      }
    }

    class MobileExtensionPoint implements ExtensionPoint {
      type: string;
      namespace: string;
      control: {};
      group: {};
      constructor(type: string, namespace?: string) {
        this.type = type;
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }
      parse(context: ParsingContext, node): void {
        switch (this.type) {
          case "MobileMessageReadCommandSurface":
            let mobileGroupNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Group", node);
            if (mobileGroupNode != null) {
              let mobileGroup = new MobileGroup(this.namespace);
              mobileGroup.parse(context, mobileGroupNode);
              this.group = mobileGroup;
            }
            break;
          case "MobileMessageComposeCommandSurface":
          case "MobileAppointmentOrganizerCommandSurface":
          case "MobileAppointmentAttendeeCommandSurface":
            break;
          case "MobileOnlineMeetingCommandSurface":
          case "MobileLogEventAppointmentAttendee":
            let mobileControlNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Control", node);
            if (mobileControlNode != null) {
              let mobileControl = new MobileControl(this.namespace);
              mobileControl.parse(context, mobileControlNode);
              this.control = mobileControl;
            }
            break;
          default:
            throw new AddInManifestException("Unsupported Mobile extension type.");
        }
      }
      apply(context: AddinBuildingContext): void {}
      parseFromMos(context: ParsingContext): void {}
    }

    class MobileGroup {
      labelResId: string;
      label: string;
      control: MobileControl;
      namespace: string;
      constructor(namespace?: string) {
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      parse(context: ParsingContext, node): void {
        var labelNode = context.getLabelChildNode(node, this.namespace);
        if (labelNode) {
          this.labelResId = context.parseResId(labelNode);
          if (this.labelResId) {
            this.label = context.getShortString(labelNode);
          }
        }

        var controlNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Control", node);
        if (controlNode) {
          // this.control = new MobileControl(this.namespace);
          this.control = new MobileControl(this.namespace);
          this.control.parse(context, controlNode);
        }
      }
      apply(context: AddinBuildingContext): void {}
      parseFromMos(context: ParsingContext): void {}
    }

    class MobileControl {
      action: ExtensionPointAction;
      actionType: string;
      labelResId: string;
      label: string;
      icon: MobileIcon;
      namespace: string;
      superTip: SuperTip;

      constructor(namespace?: string) {
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      parse(context: ParsingContext, node): void {
        var labelNode = context.getLabelChildNode(node, this.namespace);
        if (labelNode) {
          this.labelResId = context.parseResId(labelNode);
          if (this.labelResId) {
            this.label = context.getShortString(labelNode);
          }
        }

        var iconNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Icon", node);
        if (iconNode) {
          this.icon = new MobileIcon(this.namespace);
          this.icon.parse(context, iconNode);
        }

        var child = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Action", node);
        var actionType = context.manifest.getNodeXsiType(child);
        var action: ActionBase;

        switch (actionType) {
          case "ShowTaskpane":
            action = new ShowTaskPaneAction(actionType, this.namespace);
            break;
          case "ExecuteFunction":
            var execAction = (action = new ExecuteFunctionAction(actionType, this.namespace));
            // execAction.controlId = this.id;
            break;
          default:
            throw new AddInManifestException("Unsupported action type.");
        }
        if (action) {
          action.parse(context, child);
          this.actionType = actionType;
          this.action = action;
        }
      }
      apply(context: AddinBuildingContext): void {}
      parseFromMos(context: ParsingContext): void {}
    }

    class MobileIcon {
      namespace: string;
      images: MobileImage[];

      constructor(namespace?: string) {
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
        this.images = [];
      }

      parse(context: ParsingContext, node): void {
        let imageNodes = context.manifest._xmlProcessor.selectNodes("bt:Image", node);
        if (imageNodes) {
          let len = imageNodes.length;
          for (let i = 0; i < len; i++) {
            let imageNode: any = imageNodes[i];
            if (imageNode != null) {
              let image: MobileImage = new MobileImage(this.namespace);
              image.parse(context, imageNode);
              this.images.push(image);
            }
          }
        }
      }
      apply(context: AddinBuildingContext): void {}
      parseFromMos(context: ParsingContext): void {}
    }

    class MobileImage {
      size: string;
      scale: string;
      resid: string;
      namespace: string;

      constructor(namespace?: string) {
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      parse(context: ParsingContext, node): void {
        if (node) {
          this.size = node.getAttribute("size");
          this.scale = node.getAttribute("scale");
          this.resid = node.getAttribute("resid");
        }
      }
      apply(context: AddinBuildingContext): void {}
      parseFromMos(context: ParsingContext): void {}
    }

    class RibbonExtensionPoint implements ExtensionPoint {
      type: string;
      tabs: RibbonTab[];
      namespace: string;

      constructor(type: string, namespace?: string) {
        this.type = type;
        this.tabs = [];
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      apply(context: AddinBuildingContext): void {
        if (this.type == context.builder.commandSurface) {
          var len = this.tabs.length;
          var officeTabCount = 0;
          var customTabCount = 0;
          for (var i = 0; i < len; i++) {
            var tab = this.tabs[i];

            if (tab.isOfficeTab && officeTabCount < 1) {
              officeTabCount++;
            } else if (!tab.isOfficeTab && (customTabCount < 1 || context.multipleCustomTabsEnabled)) {
              customTabCount++;
            } else {
              break;
            }

            tab.apply(context);
          }
        }
      }

      parse(context: ParsingContext, node): void {
        let tabNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "OfficeTab", node);
        if (tabNode != null) {
          let tab = new RibbonTab(true, this.namespace);
          tab.parse(context, tabNode);
          this.tabs.push(tab);
        }

        // Parse custom tabs
        let tabNodes = context.manifest._xmlProcessor.selectNodes(this.namespace + "CustomTab", node);
        if (tabNodes) {
          let len = tabNodes.length;
          for (let i = 0; i < len; i++) {
            tabNode = tabNodes[i];
            if (tabNode != null) {
              let tab = new RibbonTab(false, this.namespace);
              tab.parse(context, tabNode);
              this.tabs.push(tab);
            }
          }
        }

        if (typeof otel !== "undefined" && typeof otel.sendTelemetryEvent !== "undefined") {
          if (
            !OSF.OUtil.sendTelemetryEvent("Office.Online.Extensibility.Ribbon.OfficeGroupControlCount", [
              { name: "OfficeControlCount", int64: context.officeControlCount },
              { name: "OfficeGroupCount", int64: context.officeGroupCount },
              { name: "InsertBefore", string: JSON.stringify(context.insertBefore) },
              { name: "InsertAfter", string: JSON.stringify(context.insertAfter) },
            ])
          ) {
            otel.sendTelemetryEvent({
              name: "Office.Online.Extensibility.Ribbon.OfficeGroupControlCount",
              dataFields: [
                { name: "OfficeControlCount", int64: context.officeControlCount },
                { name: "OfficeGroupCount", int64: context.officeGroupCount },
                { name: "InsertBefore", string: JSON.stringify(context.insertBefore) },
                { name: "InsertAfter", string: JSON.stringify(context.insertAfter) },
              ],
            });
          }
        }
      }

      parseFromMos(context: ParsingContext, tabs: Mos.Tabs[]): void {
        if (tabs != null) {
          for (const tab of tabs) {
            let newTab: RibbonTab;

            if (tab.builtInTabId != null) {
              newTab = new RibbonTab(true /* officeTab */);
            } else {
              newTab = new RibbonTab(false /* customTab */);
            }

            newTab.parseFromMos(context, tab);
            this.tabs.push(newTab);
          }
        }

        if (typeof otel !== "undefined" && typeof otel.sendTelemetryEvent !== "undefined") {
          if (
            !OSF.OUtil.sendTelemetryEvent("Office.Online.Extensibility.Ribbon.OfficeGroupControlCount", [
              { name: "OfficeControlCount", int64: context.officeControlCount },
              { name: "OfficeGroupCount", int64: context.officeGroupCount },
              { name: "InsertBefore", string: JSON.stringify(context.insertBefore) },
              { name: "InsertAfter", string: JSON.stringify(context.insertAfter) },
            ])
          ) {
            otel.sendTelemetryEvent({
              name: "Office.Online.Extensibility.Ribbon.OfficeGroupControlCount",
              dataFields: [
                { name: "OfficeControlCount", int64: context.officeControlCount },
                { name: "OfficeGroupCount", int64: context.officeGroupCount },
                { name: "InsertBefore", string: JSON.stringify(context.insertBefore) },
                { name: "InsertAfter", string: JSON.stringify(context.insertAfter) },
              ],
            });
          }
        }
      }
    }

    class OfficeMenuNode implements UIControlNode {
      id: string;
      type: string;
      children: UIControlNode[];
      namespace: string;

      constructor(namespace?: string) {
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      parse(context: ParsingContext, node): void {
        if (!context.shouldParseNode(node)) {
          return;
        }

        this.id = context.parseIdRequired(node);
        if (context.manifest.isForOfficeAppManifest()) {
          this.type = context.parseType(node);
        }

        this.children = context.parseChildControls(this.namespace + "Control", node, (context, node) => {
          return context.parseControlInGroup(node);
        });
      }

      parseFromMos(context: ParsingContext, menu: Mos.Menus): void {
        if (!context.shouldParseNodeFromMos(menu)) {
          return;
        }

        this.id = context.getContextMenuType(menu);
        this.children = context.parseControlsFromMos(
          menu.controls,
          (context: ParsingContext, control: Mos.Controls) => {
            return context.parseControlInGroupFromMos(control);
          },
        );
      }

      apply(context: UIControlBuildingContext): void {
        context.controlBuilder.startBuildMenu({
          id: this.id,
          label: null,
          superTip: null,
        });
        BuildHelpers.buildControls(context, this.children);
        context.controlBuilder.endBuildMenu();
      }
    }

    class ContextMenuExtensionPoint implements ExtensionPoint {
      type: string;
      children: UIControlNode[];
      namespace: string;

      constructor(type: string, namespace?: string) {
        this.type = type;
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      apply(context: AddinBuildingContext): void {
        if (this.type == context.builder.commandSurface) {
          BuildHelpers.buildControls(
            {
              functionFile: context.functionFile,
              actionBuilder: context.builder.actionBuilder,
              controlBuilder: context.builder.contextMenuBuilder,
            },
            this.children,
          );
        }
      }

      parse(context: ParsingContext, node): void {
        this.children = context.parseChildControls(this.namespace + "OfficeMenu", node, (context, node) => {
          var menu = new OfficeMenuNode(this.namespace);
          menu.parse(context, node);
          return menu;
        });
      }

      parseFromMos(context: ParsingContext, contextMenu: Mos.ContextMenus): void {
        this.children = context.parseChildControlsFromMos(
          "OfficeMenu",
          contextMenu,
          (context: ParsingContext, menu: Mos.Menus) => {
            let newMenu: OfficeMenuNode = new OfficeMenuNode();
            newMenu.parseFromMos(context, menu);
            return newMenu;
          },
        );
      }
    }

    export class CustomFunctionsExtensionPoint implements ExtensionPoint {
      type: string;
      namespaceResId: string;
      scriptResId: string;
      pageResId: string;
      metadataResId: string;

      constructor(type: string) {
        this.type = type;
      }

      apply(context: AddinBuildingContext): void {}

      parse(context: ParsingContext, node): void {
        var namespaceNode = context.manifest._xmlProcessor.selectSingleNode("ov:Namespace", node);
        if (namespaceNode) {
          this.namespaceResId = namespaceNode.getAttribute("resid");
        }

        var scriptNode = context.manifest._xmlProcessor.selectSingleNode("ov:Script", node);
        if (scriptNode) {
          this.scriptResId = this._parseSourceLocationResId(context, scriptNode);
        }
        if (!this.scriptResId) {
          throw new AddInManifestException(
            "Missing required <Script> element under element <ExtensionPoint xsi:type='CustomFunctions'>.",
          );
        }

        var pageNode = context.manifest._xmlProcessor.selectSingleNode("ov:Page", node);
        if (pageNode) {
          this.pageResId = this._parseSourceLocationResId(context, pageNode);
        }
        if (!this.pageResId) {
          throw new AddInManifestException(
            "Missing required <Page> element under element <ExtensionPoint xsi:type='CustomFunctions'>.",
          );
        }

        var metadataNode = context.manifest._xmlProcessor.selectSingleNode("ov:Metadata", node);
        if (metadataNode) {
          this.metadataResId = this._parseSourceLocationResId(context, metadataNode);
        }
        if (!this.metadataResId) {
          throw new AddInManifestException(
            "Missing required <Metadata> element under element <ExtensionPoint xsi:type='CustomFunctions'>.",
          );
        }
      }

      parseFromMos(context: ParsingContext, node: any): void {
        // TODO: Not Implemented
      }

      _parseSourceLocationResId(context: ParsingContext, node): string {
        var sourceLocationNode = context.manifest._xmlProcessor.selectSingleNode("ov:SourceLocation", node);
        if (sourceLocationNode) {
          return sourceLocationNode.getAttribute("resid");
        }
        return undefined;
      }
    }

    class AutoRunEvent implements NodeParser {
      type: string;
      functionName: string;
      sendMode: string;

      parse(context: ParsingContext, node): void {
        this.type = node.getAttribute("Type");
        this.functionName = node.getAttribute("FunctionName");
        this.sendMode = node.getAttribute("SendMode");
      }

      parseFromMos(context: ParsingContext, node: any): void {
        // Not Implemented. Outlook is not using our parser.
      }
    }

    class AutoRunExtensionPoint implements ExtensionPoint {
      type: string;
      namespace: string;
      events: AutoRunEvent[];
      resid: string;

      constructor(type: string, namespace?: string) {
        this.type = type;
        this.events = [];
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      apply(context: AddinBuildingContext): void {
        // Not implemented for now, since it is not needed for the XML-to-JSON manifest converter.
      }

      parse(context: ParsingContext, node): void {
        let launchEventsNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "LaunchEvents", node);
        if (launchEventsNode == null) {
          throw new AddInManifestException(
            "Missing required <LaunchEvents> element under element <ExtensionPoint xsi:type='LaunchEvent'>.",
          );
        }

        let launchEventNodes = context.manifest._xmlProcessor.selectNodes(
          this.namespace + "LaunchEvent",
          launchEventsNode,
        );
        if (launchEventNodes.length == 0) {
          throw new AddInManifestException("Missing required <LaunchEvent> element under element <LaunchEvents>.");
        }

        for (let i = 0; i < launchEventNodes.length; i++) {
          let event = new AutoRunEvent();
          event.parse(context, launchEventNodes[i]);
          this.events.push(event);
        }

        let sourceLocationNode = context.manifest._xmlProcessor.selectSingleNode(
          this.namespace + "SourceLocation",
          node,
        );
        if (sourceLocationNode == null) {
          throw new AddInManifestException(
            "Missing required <SourceLocation> element under element <ExtensionPoint xsi:type='LaunchEvent'>.",
          );
        }
        this.resid = sourceLocationNode.getAttribute("resid");
      }

      parseFromMos(context: ParsingContext, node: any): void {
        // Not Implemented. Outlook is not using our parser.
      }
    }

    class ReportPhishingCommandSurfaceExtensionPoint implements ExtensionPoint {
      
      spamPreProcessingDialog: any;
      fixedControl: UIControlNode;
      type: string;
      namespace: string;

      reportingOptions: any[];

      constructor(type: string, namespace?: string) {
        this.type = type;
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      apply(context: AddinBuildingContext): void {
        // Not implemented for now, since it is not needed for the XML-to-JSON manifest converter.
      }

      parseFromMos(context: ParsingContext, node: any): void {
        // Not currently needed unless this ReportPhishing customization is implemented in WAC
      }

      parse(context: ParsingContext, node): void {
        let reportPhishingCustomizationNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "ReportPhishingCustomization", node);
        if (reportPhishingCustomizationNode == null) {
          throw new AddInManifestException(
            "Missing required <ReportPhishingCustomization> element under element <ExtensionPoint xsi:type='ReportPhishingCustomization'>.",
          );
        }

        // This structure only allows for a Button control so we assume that this is what we get
        let controlNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Control", reportPhishingCustomizationNode);
        var controlType = context.manifest.getNodeXsiType(controlNode);
        if (controlNode != null) {
          this.fixedControl = new Button(controlType, this.namespace);
          this.fixedControl.parse(context, controlNode);
        }

        // Parse the <SourceLocation>
        let srcLocationNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "SourceLocation", reportPhishingCustomizationNode);
        if (srcLocationNode != null) {
          this.fixedControl["sourceLocationResid"] = srcLocationNode.getAttribute("resid");
        }

        // Now parse the <PreProcessingDialog>
        let preProcessingDialogNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "PreProcessingDialog", reportPhishingCustomizationNode);

        if (preProcessingDialogNode != null) {

          this.spamPreProcessingDialog = {};

          // Parse <Title>
          let titleNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Title", preProcessingDialogNode);
          if (titleNode != null) {
            this.spamPreProcessingDialog.titleResId = titleNode.getAttribute("resid");
          }

          // Parse <Description>
          let descriptionNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Description", preProcessingDialogNode);
          if (descriptionNode != null) {
            this.spamPreProcessingDialog.descriptionResId = descriptionNode.getAttribute("resid");
          }

          // Parse <FreeTextLabel>
          let freeTextLabelNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "FreeTextLabel", preProcessingDialogNode);
          if (freeTextLabelNode != null) {
            this.spamPreProcessingDialog.spamFreeTextSectionLabelResId = freeTextLabelNode.getAttribute("resid");
          }

          // Now parse the <MoreInfo>
          let moreInfoNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "MoreInfo", preProcessingDialogNode);
          if (moreInfoNode != null) {
            this.spamPreProcessingDialog.spamMoreInfo = {};
            // Parse <MoreInfoText>
            let moreInfoTextNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "MoreInfoText", moreInfoNode);
            if (moreInfoTextNode != null) {
              this.spamPreProcessingDialog.spamMoreInfo.textResId = moreInfoTextNode.getAttribute("resid");
            }

            // Parse <MoreInfoUrl>
            let moreInfoUrlNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "MoreInfoUrl", moreInfoNode);
            if (moreInfoUrlNode != null) {
              this.spamPreProcessingDialog.spamMoreInfo.urlResId = moreInfoUrlNode.getAttribute("resid");
            }
          }

          // Now parse the <ReportingOptions>
          let reportingOptionsNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "ReportingOptions", preProcessingDialogNode);
          if (reportingOptionsNode != null) {
            this.spamPreProcessingDialog.spamReportingOptions = {};
            // Parse <ReportingOptions><Title>
            let titleNode = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Title", reportingOptionsNode);
            if (titleNode != null) {
              this.spamPreProcessingDialog.spamReportingOptions.titleResId = titleNode.getAttribute("resid");
            }

            let optionNodes = context.manifest._xmlProcessor.selectNodes(this.namespace + "Option", reportingOptionsNode);

            if (optionNodes != null) {
              this.spamPreProcessingDialog.spamReportingOptions.options = [];

              for (var i = 0; i < optionNodes.length; i++) {
                var optionNode = optionNodes[i];
                let opt: string = optionNode.getAttribute("resid");
                this.spamPreProcessingDialog.spamReportingOptions.options.push(opt);
              }
            }
          }
        }
      }
    }

    export class VersionOverrides implements Addin {
      // Template manifest of all extensions
      private extensionManifest: Manifest;
      private extensionEntitlement: AddinEntitlement;
      type: string;
      description: string;
      getStartedNode: GetStartedNode = null;
      functionFile: string = null;
      functionFileResid: string = null;
      ExtensionPoints: ExtensionPoint[];
      cacheableUrls: Array<string>;
      resources: ManifestResourceManager;
      namespace: string;
      supportsSharedFolders: boolean = false;

      constructor(namespace?: string) {
        this.cacheableUrls = [];
        this.ExtensionPoints = [];
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      cacheableResources(): Array<string> {
        return this.cacheableUrls;
      }

      apply(builder: AddinBuilder, errorManager: AddinCommandsErrorManager, multipleCustomTabsEnabled = false): void {
        try {
          builder.startApplyAddin({
            entitlement: this.extensionEntitlement,
            manifest: this.extensionManifest,
            startedNode: this.getStartedNode,
            overrides: {
              type: this.type,
              description: this.description,
            },
          });

          var context = new AddinBuildingContext(this.functionFile, builder, multipleCustomTabsEnabled);
          var len = this.ExtensionPoints.length;
          for (var i = 0; i < len; i++) {
            var ext = this.ExtensionPoints[i];
            ext.apply(context);
          }

          builder.endApplyAddin();
        } catch (ex) {
          if (ex instanceof AddInManifestException) {
            errorManager.setErrorMessageForAddin(
              Telemetry.PrivacyRules.GetPrivacyCompliantId(
                this.extensionEntitlement.solutionId,
                this.extensionEntitlement.storeType,
                this.extensionEntitlement.assetId,
                null,
                null,
                this.extensionEntitlement.storeId,
              ),
              Strings.OsfRuntime.L_AddinCommands_AddinNotSupported_Message,
            );
          }

          if (OSF.OUtil.checkFlight(OSF.FlightNames.ManifestParserDevConsoleLog)) {
            DevConsole.log(ex);
          }

          throw ex;
        }
      }

      parse(context: ParsingContext, overridesNode): void {
        this.type = context.manifest.getNodeXsiType(overridesNode);
        var node = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "Description", overridesNode);
        if (node != null) {
          this.description = context.getLongString(node);
        }

        var hostNodes = OSF.SelectChildNodes(context.manifest._xmlProcessor, this.namespace + "Host", overridesNode, [
          this.namespace + "Hosts",
        ]);

        var formFactorNode = null;
        var len = hostNodes.length;
        for (var i = 0; i < len; i++) {
          var hostNode = hostNodes[i];
          var hostType = context.manifest.getNodeXsiType(hostNode);
          if (hostType == context.hostType) {
            formFactorNode = context.manifest._xmlProcessor.selectSingleNode(
              this.namespace + context.formFactor,
              hostNode,
            );
            if (formFactorNode == null) {
              formFactorNode = context.manifest._xmlProcessor.selectSingleNode(
                this.namespace + "AllFormFactors",
                hostNode,
              );
            }
            break;
          }
        }

        var startedNode = context.manifest._xmlProcessor.selectSingleNode(
          this.namespace + "GetStarted",
          formFactorNode,
        );
        if (startedNode != null) {
          this.getStartedNode = new GetStartedNode(this.namespace);
          this.getStartedNode.parse(context, startedNode);
        }

        node = context.manifest._xmlProcessor.selectSingleNode(this.namespace + "FunctionFile", formFactorNode);
        if (node != null) {
          this.functionFileResid = node.getAttribute("resid");
          if (OSF.OUtil.isChangeGateEnabled("VSO8544149_ManifestNotValidInWacSideload")) {
            // if lookup of function file resource fails, don't fail entire manifest parse immediately because some manifests
            // don't actually invoke it. The rich clients treat such manifests as valid, so we want the WAC to do the same.
            try {
              this.functionFile = context.getUrlResource(node);
              context.manifest.addManifestUrl(this.functionFile);
            } catch (ex) {
              this.functionFile = null;
            }
          } else {
            this.functionFile = context.getUrlResource(node);
            context.manifest.addManifestUrl(this.functionFile);
          }
        }

        if (context.manifest.isForOfficeAppManifest()) {
          node = context.manifest._xmlProcessor.selectSingleNode(
            this.namespace + "SupportsSharedFolders",
            formFactorNode,
          );
          if (node != null) {
            this.supportsSharedFolders = context.manifest._parseBooleanNode(node);
          }
        }

        var extNodes = context.manifest._xmlProcessor.selectNodes(this.namespace + "ExtensionPoint", formFactorNode);
        len = extNodes.length;
        for (var i = 0; i < len; i++) {
          var extNode = extNodes[i];
          var extType = context.manifest.getNodeXsiType(extNode);
          let ext: ExtensionPoint = null;

          switch (extType) {
            case "Events":
              if (context.manifest.isForOfficeAppManifest()) {
                // Events is unsupported extension type for the xml to json manifest converter, so log an error and skip it
                console.error(
                  "\x1b[31m%s\x1b[0m",
                  'ExtensionPoint type "Events" in the XML manifest "' +
                    context.manifest.getDefaultDisplayName() +
                    '" is not supported. Please change the type to "LaunchEvent" and then convert it to metaOS manifest.',
                );
                continue;
              }
              throw "Not Implemented";

            case "PrimaryCommandSurface":
              ext = new RibbonExtensionPoint(extType, this.namespace);
              break;

            case "ContextMenu":
              ext = new ContextMenuExtensionPoint(extType, this.namespace);
              break;

            case "CustomFunctions":
              ext = new CustomFunctionsExtensionPoint(extType);
              break;

            case "LaunchEvent":
              ext = new AutoRunExtensionPoint(extType, this.namespace);
              break;

            default:
              if (context.manifest.isForOfficeAppManifest()) {
                switch (extType) {
                  case "MessageReadCommandSurface":
                  case "MessageComposeCommandSurface":
                  case "AppointmentOrganizerCommandSurface":
                  case "AppointmentAttendeeCommandSurface":
                    ext = new RibbonExtensionPoint(extType, this.namespace);
                    break;
                  case "MobileMessageReadCommandSurface":
                  case "MobileMessageComposeCommandSurface":
                  case "MobileAppointmentOrganizerCommandSurface":
                  case "MobileAppointmentAttendeeCommandSurface":
                  case "MobileOnlineMeetingCommandSurface":
                  case "MobileLogEventAppointmentAttendee":
                    if (context.manifest.isForOfficeAppManifest()) {
                      ext = new MobileExtensionPoint(extType, this.namespace);
                    } else {
                      ext = new RibbonExtensionPoint(extType, this.namespace);
                    }
                    break;
                  case "ReportPhishingCommandSurface":
                    ext = new ReportPhishingCommandSurfaceExtensionPoint(extType, this.namespace);
                    break;
                  default:
                    OSF["AppTelemetry"]?.logAppCommonMessage?.("Ignoring unsupported extension point type: " + extType);
                    continue;
                }
              } else {
                throw new AddInManifestException("Unsupported extension type.");
              }
          }

          ext.parse(context, extNode);
          this.ExtensionPoints.push(ext);
        }

        // Cacheable resources
        var images = context.resources.Images;
        for (var e in images) {
          this.cacheableUrls.push(images[e]);
        }

        this.extensionEntitlement = context.entitlement;
        this.extensionManifest = context.manifest;
        this.resources = context.resources;
      }

      parseFromMos(context: ParsingContext) {
        let description: string = context.manifest.getDescription();
        if (description != null) {
          this.description = description;
        }

        const getStartedMessage: Mos.GetStartedMessages = context.manifest.getExtensionGetStartedMessage();
        if (getStartedMessage != null) {
          this.getStartedNode = new GetStartedNode(this.namespace);
          this.getStartedNode.parseFromMos(context, getStartedMessage);
        }

        const runtimes: Mos.Runtimes[] = context.manifest.getExtensionRuntimes();
        for (const runtime of runtimes) {
          if (!Mos.AppMetadata.isLegacyRuntime(runtime)) {
            this.functionFile = runtime.code.page;
            this.functionFileResid = runtime.id;
            break;
          }
        }

        const ribbon: Mos.Ribbons = context.manifest.getExtensionRibbon();
        if (ribbon != null) {
          let primaryExtension: RibbonExtensionPoint = new RibbonExtensionPoint("PrimaryCommandSurface");
          primaryExtension.parseFromMos(context, ribbon.tabs);
          this.ExtensionPoints.push(primaryExtension);
        }

        const contextMenu: Mos.ContextMenus = context.manifest.getExtensionContextMenu();
        if (contextMenu != null) {
          let contextMenuExtension: ContextMenuExtensionPoint = new ContextMenuExtensionPoint("ContextMenu");
          contextMenuExtension.parseFromMos(context, contextMenu);
          this.ExtensionPoints.push(contextMenuExtension);
        }

        // TODO: parseFromMos CustomFunciton

        let images: {} = context.resources.Images;
        for (let e in images) {
          this.cacheableUrls.push(images[e]);
        }

        this.extensionEntitlement = context.entitlement;
        this.extensionManifest = context.manifest;
      }
    }

    class emptyAddin implements Addin {
      cacheableResources(): Array<string> {
        // No resources
        return [];
      }

      apply(builder: AddinBuilder, errorManager: AddinCommandsErrorManager): void {
        // No extension
      }
    }

    export class AddinCommandsManifestParser {
      hostType: string;
      formFactor: string;
      namespace: string;

      constructor(hostType, formFactor, namespace?: string) {
        this.hostType = hostType;
        this.formFactor = formFactor;
        this.namespace = OSF.GetNamespaceOrDefault(namespace);
      }

      parseExtensions(
        entitlement: AddinEntitlement,
        manifest: Manifest,
        errorManager: AddinCommandsErrorManager,
        versionOverridesNumber?: OSF.VersionOverridesNumber,
      ): Addin {
        try {
          if (manifest.getPayloadType() === OSF.PayloadType.MosAcquisition) {
            let versionOverrides: VersionOverrides = new VersionOverrides();
            versionOverrides.parseFromMos(new ParsingContext(this.hostType, this.formFactor, entitlement, manifest));

            return versionOverrides;
          } else {
            var officeAppNode = manifest._xmlProcessor.selectSingleNode("o:OfficeApp");
            var overridesNode = manifest._xmlProcessor.selectSingleNode(
              this.namespace + "VersionOverrides",
              officeAppNode,
            );
            if (overridesNode == null) {
              return new emptyAddin();
            }

            if (manifest.isForOfficeAppManifest()) {
              // As Outlook has two versionOverrides we need to parse 1_0 and 1_1 based on versionOverridesNumber
              if (this.hostType === "MailHost" && versionOverridesNumber) {
                let versionOverridesNodePath: string[] = OSF.GetVersionOverridesPath(
                  manifest._xmlProcessor,
                  this.namespace,
                  versionOverridesNumber,
                );
                let versionOverridesNodeTemp: any = OSF.SelectSingleNode(
                  manifest._xmlProcessor,
                  officeAppNode,
                  versionOverridesNodePath,
                  true /*isStrictPath*/,
                );
                let versionOverridesType: string = manifest.getNodeXsiType(versionOverridesNodeTemp);
                let versionOverridesString: string = OSF.GetVersionOverridesString(versionOverridesNumber);
                if (versionOverridesType === versionOverridesString) {
                  overridesNode = versionOverridesNodeTemp;
                }
              }
            }

            let context: ParsingContext = new ParsingContext(
              this.hostType,
              this.formFactor,
              entitlement,
              manifest,
              this.namespace,
              versionOverridesNumber,
            );
            let ns: string = OSF.GetVersionOverridesNamespace(this.namespace, versionOverridesNumber);
            var versionOverrides = new VersionOverrides(ns);
            // ParsingContext needs 'this.namespace' to load the resources in its constructor. It then needs to use 'ns' for parsing.
            context.namespace = ns;
            versionOverrides.parse(context, overridesNode);
            return versionOverrides;
          }
        } catch (ex) {
          if (ex instanceof AddInManifestException) {
            errorManager.setErrorMessageForAddin(
              Telemetry.PrivacyRules.GetPrivacyCompliantId(
                entitlement.solutionId,
                entitlement.storeType,
                entitlement.assetId,
                null,
                null,
                entitlement.storeId,
              ),
              Strings.OsfRuntime.L_AddinCommands_AddinNotSupported_Message,
            );
          }

          if (OSF.OUtil.checkFlight(OSF.FlightNames.ManifestParserDevConsoleLog)) {
            DevConsole.log(ex);
          }

          throw ex;
        }
      }
    }
  }
}
